import React from "react";
import "../ShareHolderInfo.scss";
import shareholderInvestor2022 from "../../../files/shareholder-info/Notice of Shareholders(unpaid dividend-2022).pdf";

const ShareholderInvestorNotice = () => {
  return (
    <>
      <div className="shareholder_info">
        <div className="container">
          <div className="heading_box">Shareholders/Investors Notice</div>
          <div className="dividend_report_link">
            <ul>
              <li>
                <a
                  href={shareholderInvestor2022}
                  target="_blank"
                  rel="noreferrer"
                >
                  Unpaid/Unclaimed Cash and Stock/Bonus Dividend 27th April,
                  2022
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShareholderInvestorNotice;
